import { useEffect, useRef } from "react";

import { useAuth } from "@/hooks/use-auth";
import { useMediaDownloadReset } from "@/hooks/use-media-download";

// NOTE: MediaDownloadProvider is mounted above AuthProvider so downloads survive
// route navigation (incl. the /admin ↔ /* boundary). That also means its state
// would otherwise outlive a sign-out. This sync lives *inside* the authenticated
// tree, so when the authenticated identity changes (logout or account switch) it
// aborts and clears every in-flight download — preventing one user's meeting
// title / progress / already-authorized download from leaking into the next
// session (CWE-200). Downloads still persist across navigation within one
// authenticated session. Renders nothing.
const MediaDownloadAuthSync = (): null => {
  const { user } = useAuth();
  const clearAll = useMediaDownloadReset();

  const identity = user?.uuid ?? null;
  const previousIdentityRef = useRef<string | null>(identity);

  useEffect(() => {
    if (
      previousIdentityRef.current !== null &&
      previousIdentityRef.current !== identity
    ) {
      clearAll();
    }
    previousIdentityRef.current = identity;
  }, [identity, clearAll]);

  return null;
};

export default MediaDownloadAuthSync;
